import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { useDispatch } from "react-redux";
import { Globals } from "utils/styleconfig";
import { RiCloseFill, RiEditBoxLine } from "react-icons/ri";
import Button from "components/UI/Button/Button";

import List from "components/List/List";
import utilityStyles from "styles/modules/Utility.module.scss";
import { useGetQueueTierByIdQuery } from "features/call_center/queueTiersApiSlice";
import EditTier from "../EditTier/EditTier";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";

const ViewQueueTier = ({ label }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isEditVisible, setEditVisible] = useState(false);

  useEffect(() => {
    dispatch(setNavbarTitle("View Queue Tier"));
  }, [dispatch]);

  // Fetch queue tier details
  const { data: queueTier, isLoading } = useGetQueueTierByIdQuery({ queueId: params?.id, tierId: params?.tierId });

  const toggleEditVisibility = () => {
    setEditVisible(!isEditVisible);
  };

  const queueTierData = [
    { label: "Agent Name", value: queueTier?.agent?.name },
    { label: "Agent Contact", value: queueTier?.agent?.contact },
    { label: "Agent Status", value: queueTier?.agent?.status },
    { label: "Agent Enabled", value: queueTier?.agent?.enabled ? "Yes" : "No" },
    { label: "Domain", value: queueTier?.domain?.name || "" },
    { label: "Level", value: queueTier?.level },
    { label: "Position", value: queueTier?.position },
    { label: "Enabled", value: queueTier?.enabled ? "Yes" : "No" },
    { label: "Date Created", value: new Date(queueTier?.created_at).toLocaleString() },
  ];

  return (
    <>
      <div className={`${utilityStyles.grid} ${utilityStyles.grid_col2} ${utilityStyles.gap10}`}>
        <div className={`${utilityStyles.flexColumn} ${utilityStyles.justifyStart} ${utilityStyles.gap10} ${utilityStyles.colorWhite} ${utilityStyles.dataList}`}>
          <List customStyle={`${utilityStyles.grid} ${utilityStyles.gap10}`} data={queueTierData} />
          {isLoading ? (
            <TableSkeleton />
          ) : (
            <div>
              <Button onClick={toggleEditVisibility} className={`${utilityStyles.btn}`}>
                {isEditVisible ? (
                  <RiCloseFill color={Globals.colorRed} size={30} />
                ) : (
                  <>
                    <h3>Edit Tier</h3>
                    <RiEditBoxLine color={Globals.colorDarkBlue} size={20} />
                  </>
                )}
              </Button>
            </div>
          )}
        </div>
      </div>

      {isEditVisible && (
        <EditTier label={label} />
      )}
    </>
  );
};

export default ViewQueueTier;
